<template>
    <Image
        v-once
        src="/BO_Service_Logo.svg"
        alt="boService logo"
        image-class="h-[50px] my-4 object-contain"
    />
</template>
